import { render, staticRenderFns } from "./DocAnt.vue?vue&type=template&id=3106683a&lang=html&"
import script from "./DocAnt.vue?vue&type=script&lang=js&"
export * from "./DocAnt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports